// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"47":"9a0e1acd","297":"f485d21e","897":"d1cf7998"}[chunkId] + ".chunk.js";
};